import React, { useEffect, useState } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import LoaderUI from "../../../components/common/loader";
import NoRecord from "../../../components/common/NoRecord";
import DocumentItem from "../DocumentItem";
import { toast } from "react-toastify";
import "./index.scss";
import "react-toastify/dist/ReactToastify.css";
toast.configure();

/**
 * @description component use for update/add location
 */
const DocumentsViewModal = ({
  title,
  showModel,
  _submit,
  _toggle,
  _detail,
  _update,
  disabled,
  lodder,
  records,
  count,
  _moveToCronJob,
  _requeue,
  _reQueueDocument,
  _removeQueueDocument,
  filterSelected

}) => {
 
console.log('records',records)

  return (
    <>
      <Modal isOpen={showModel} toggle={() => _toggle()} backdrop="static" style={{ maxHeight: '500px', overflowY: 'auto', top: '50%', transform: 'translateY(-50%)' }}>
        <ModalHeader>
          {title}
          {records?.length && filterSelected != 'deleted' ? <Button className="marginLeft" onClick={()=>{_moveToCronJob()}}>Try Again</Button> :'' }
          <Button color="link" onClick={() => _toggle()}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="34"
              height="34"
              viewBox="0 0 34 34"
            >
              <g data-name="Group 651" transform="translate(-1535 -134)">
                <g
                  fill="#fff"
                  stroke="#000"
                  strokeWidth="2"
                  data-name="Ellipse 30"
                  opacity="0.3"
                  transform="translate(1535 134)"
                >
                  <circle cx="17" cy="17" r="17" stroke="none"></circle>
                  <circle cx="17" cy="17" r="16" fill="none"></circle>
                </g>
                <path
                  d="M19.589 18l4.8-4.8a1.124 1.124 0 00-1.589-1.584l-4.8 4.8-4.8-4.8a1.124 1.124 0 10-1.584 1.584l4.8 4.8-4.8 4.8a1.124 1.124 0 001.584 1.584l4.8-4.8 4.8 4.8a1.124 1.124 0 101.584-1.584z"
                  data-name="Icon ionic-ios-close"
                  opacity="0.3"
                  transform="translate(1534.289 132.789)"
                ></path>
              </g>
            </svg>
          </Button>
        </ModalHeader>
        <ModalBody>

          {records?.length && records?.length !== 0
            ? <DocumentItem
              _filterSelected={filterSelected}
              records={records}
              requeue={_requeue}
              _reQueueDocument={_reQueueDocument}
              _removeQueueDocument={_removeQueueDocument}
            />
            : records?.length === 0 && <NoRecord />}


        </ModalBody>
        <ModalFooter>

        </ModalFooter>
      </Modal>
      {lodder && <LoaderUI className="modal-overlay-level-1" overlay />}
    </>
  );
};

export default DocumentsViewModal;
